import * as Yup from 'yup'

import { getShowBudgetStep } from './helpers'

import {
  NAME,
  OBJECTIVE,
  BUDGET_DAILY,
  CAMPAIGN_BUDGET,
  NO_BUDGET,
  SPECIAL_AD_CATEGORIES,
  CATEGORY_CREDIT,
  CATEGORY_EMPLOYMENT,
  CATEGORY_HOUSING,
  DO_NOT_ASK_CATEGORY,
  specialAdCategories,
  BUDGET_LIFETIME
} from '../../../../Multiplatform/CampaignForms/fields'
import { CONVERSIONS, ENGAGEMENT, REACH, TRAFFIC, VIDEO_VIEWS } from '../../../../../constants/campaigns'
import { OPTION_NO, OPTION_YES } from '../../../../../constants/forms'

import nameValidation from '../../../../../features/validations/name'

export const optimizeGoals = {
  [TRAFFIC]: 'CLICK',
  [CONVERSIONS]: 'CONVERT',
  [REACH]: 'REACH',
  [VIDEO_VIEWS]: 'ENGAGED_VIEW',
  [ENGAGEMENT]: 'FOLLOWERS'
}

export const BUDGET_LIMIT_OPTION = 'budget_limit_option'
export const BUDGET_LIFETIME_LIMIT = 'budget_lifetime_limit'
export const BUDGET_DAILY_LIMIT = 'budget_daily_limit'
export const BUDGET_NO_LIMIT = 'no_budget_limit'

export const initialValues = {
  [NAME]: '',
  [OBJECTIVE]: CONVERSIONS,
  // budget
  [CAMPAIGN_BUDGET]: BUDGET_LIFETIME,
  [BUDGET_LIFETIME]: '',
  [BUDGET_DAILY]: '',
  // budget limit
  [BUDGET_LIMIT_OPTION]: BUDGET_LIFETIME_LIMIT,
  [BUDGET_LIFETIME_LIMIT]: '',
  [BUDGET_DAILY_LIMIT]: '',
  // special ad categories
  // special ad categories
  [SPECIAL_AD_CATEGORIES]: OPTION_NO,
  [CATEGORY_CREDIT]: false,
  [CATEGORY_EMPLOYMENT]: false,
  [CATEGORY_HOUSING]: false,
  [DO_NOT_ASK_CATEGORY]: false
}

export const validationSchema = Yup.object({
  ...nameValidation,
  // budget
  [BUDGET_LIFETIME]: Yup.string().when(CAMPAIGN_BUDGET, {
    is: BUDGET_LIFETIME,
    then: () =>
      Yup.string().when(OBJECTIVE, {
        // additional check if step is showed
        is: campaignObjective => getShowBudgetStep(campaignObjective),
        then: () => Yup.string().required('Budget Required')
      })
  }),
  [BUDGET_DAILY]: Yup.string().when(CAMPAIGN_BUDGET, {
    is: BUDGET_DAILY,
    then: () =>
      Yup.string().when(OBJECTIVE, {
        // additional check if step is showed
        is: campaignObjective => getShowBudgetStep(campaignObjective),
        then: () => Yup.string().required('Budget Required')
      })
  }),
  // budget limit
  [BUDGET_LIFETIME_LIMIT]: Yup.string().when(BUDGET_LIMIT_OPTION, {
    is: BUDGET_LIFETIME_LIMIT,
    then: () =>
      Yup.string().test({
        message: 'Lifetime Budget Required',
        test: (value, { parent }) => {
          // validate if budget question wasn't asked or NO_BUDGET option was selected
          if (!getShowBudgetStep(parent[OBJECTIVE]) || parent[CAMPAIGN_BUDGET] === NO_BUDGET) {
            return !!value
          }

          return true
        }
      })
  }),
  [BUDGET_DAILY_LIMIT]: Yup.string().when(BUDGET_LIMIT_OPTION, {
    is: BUDGET_DAILY_LIMIT,
    then: () =>
      Yup.string().test({
        message: 'Daily Budget Required',
        test: (value, { parent }) => {
          // validate if budget question wasn't asked or NO_BUDGET option was selected
          if (!getShowBudgetStep(parent[OBJECTIVE]) || parent[CAMPAIGN_BUDGET] === NO_BUDGET) {
            return !!value
          }

          return true
        }
      })
  })
})

export const transformValuesToBE = (values, selectedAdAccountId, savedSettings) => {
  const budgetStepIsShown = getShowBudgetStep(values[OBJECTIVE])

  const includeBudgetLifetimeInPayload = values[CAMPAIGN_BUDGET] === BUDGET_LIFETIME && budgetStepIsShown
  const includeBudgetDailyInPayload = values[CAMPAIGN_BUDGET] === BUDGET_DAILY && budgetStepIsShown

  // the same extra conditions as for showing this step
  const includeBudgetLimitInPayload =
    values[BUDGET_LIMIT_OPTION] !== BUDGET_NO_LIMIT && (!budgetStepIsShown || values[CAMPAIGN_BUDGET] === NO_BUDGET)

  return {
    account: selectedAdAccountId,
    name: values[NAME],
    objective: values[OBJECTIVE].toUpperCase(),
    // budget
    ...(includeBudgetLifetimeInPayload && {
      budget_lifetime: values[BUDGET_LIFETIME],
      buying_type: 'BUDGET_MODE_TOTAL',
      budget_optimize_on: true
    }),
    ...(includeBudgetDailyInPayload && {
      budget_daily: values[BUDGET_DAILY],
      buying_type: 'BUDGET_MODE_DAY',
      bid_type: 'BID_TYPE_NO_BID',
      optimize_goal: optimizeGoals[values[OBJECTIVE]],
      budget_optimize_on: true
    }),
    // budget limit - in general it is just our concept and use the same budget fields
    ...(includeBudgetLimitInPayload &&
      values[BUDGET_LIMIT_OPTION] === BUDGET_LIFETIME_LIMIT && {
        budget_lifetime: values[BUDGET_LIFETIME_LIMIT],
        buying_type: 'BUDGET_MODE_TOTAL',
        budget_optimize_on: true
      }),
    ...(includeBudgetLimitInPayload &&
      values[BUDGET_LIMIT_OPTION] === BUDGET_DAILY_LIMIT && {
        budget_daily: values[BUDGET_DAILY_LIMIT],
        buying_type: 'BUDGET_MODE_DAY',
        budget_optimize_on: true
      }),
    ...(!includeBudgetLifetimeInPayload &&
      !includeBudgetDailyInPayload &&
      !includeBudgetLimitInPayload && { buying_type: 'BUDGET_MODE_INFINITE' }),
    ...(savedSettings[SPECIAL_AD_CATEGORIES] !== OPTION_NO &&
      values[SPECIAL_AD_CATEGORIES] === OPTION_YES && {
        // combine separated values in one special_ad_categories array field
        industry_types: specialAdCategories.filter(category => values[category]).map(value => value.toUpperCase())
      })
  }
}
